import { render, staticRenderFns } from "./UseTarget.vue?vue&type=template&id=ba321ebc&scoped=true"
import script from "./UseTarget.vue?vue&type=script&lang=js"
export * from "./UseTarget.vue?vue&type=script&lang=js"
import style0 from "./UseTarget.vue?vue&type=style&index=0&id=ba321ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba321ebc",
  null
  
)

export default component.exports